const API_URL = process.env.REACT_APP_API_URL

export const loginUrl = `${API_URL}/api/auth/login`
export const meUrl = `${API_URL}/api/auth/me`
export const requestForgottenPasswordUrl = `${API_URL}/api/auth/password/forget`
export const resetPasswordUrl = `${API_URL}/api/auth/password/reset`

export const fetchLicensesUrl = `${API_URL}/api/licenses`
export const fetchLicenseByIdUrl = `${API_URL}/api/licenses`
export const createLicenseUrl = `${API_URL}/api/licenses/create`
export const updateLicenseUrl = `${API_URL}/api/licenses/update`
export const deleteLicenseUrl = `${API_URL}/api/licenses/delete`
export const suspendLicenseUrl = `${API_URL}/api/licenses/suspend`
export const activateLicenseUrl = `${API_URL}/api/licenses/activate`

export const fetchUsersUrl = `${API_URL}/api/users`
export const fetchUserByIdUrl = `${API_URL}/api/users`
/** GET /api/users/online — who is connected + count (admin role 2 only) */
export const usersOnlineUrl = `${API_URL}/api/users/online`
export const fetchAllUsersUrl = `${API_URL}/api/users/all`
export const createUserUrl = `${API_URL}/api/users/create`
export const updateUserUrl = `${API_URL}/api/users/update`
export const deleteUserUrl = `${API_URL}/api/users/delete`
export const suspendUserUrl = `${API_URL}/api/users/suspend`
export const activateUserUrl = `${API_URL}/api/users/activate`
export const activateUsersExceptUrl = `${API_URL}/api/users/activate-except`
export const suspendUsersExceptUrl = `${API_URL}/api/users/suspend-except`

export const fetchEstablishementsUrl = `${API_URL}/api/establishements`
export const fetchEstablishementByIdUrl = `${API_URL}/api/establishements`
export const fetchAllEstablishementsUrl = `${API_URL}/api/establishements/all`
export const createEstablishementUrl = `${API_URL}/api/establishements/create`
export const updateEstablishementUrl = `${API_URL}/api/establishements/update`
export const deleteEstablishementUrl = `${API_URL}/api/establishements/delete`
export const suspendEstablishementUrl = `${API_URL}/api/establishements/suspend`
export const activateEstablishementUrl = `${API_URL}/api/establishements/activate`

export const fetchClassesUrl = `${API_URL}/api/classes`
export const fetchClasseByIdUrl = `${API_URL}/api/classes`
export const createClasseUrl = `${API_URL}/api/classes/create`
export const updateClasseUrl = `${API_URL}/api/classes/update`
export const deleteClasseUrl = `${API_URL}/api/classes/delete`
export const suspendClasseUrl = `${API_URL}/api/classes/suspend`
export const activateClasseUrl = `${API_URL}/api/classes/activate`
export const fetchAllClassesUrl = `${API_URL}/api/classes/all`

export const fetchSubjectsUrl = `${API_URL}/api/subjects`
export const fetchSubjectByIdUrl = `${API_URL}/api/subjects`
export const createSubjectUrl = `${API_URL}/api/subjects/create`
export const updateSubjectUrl = `${API_URL}/api/subjects/update`
export const deleteSubjectUrl = `${API_URL}/api/subjects/delete`
export const suspendSubjectUrl = `${API_URL}/api/subjects/suspend`
export const activateSubjectUrl = `${API_URL}/api/subjects/activate`
export const fetchAllSubjectsUrl = `${API_URL}/api/subjects/all`

// Grade & Tabulation Endpoints
export const createGradeUrl = `${API_URL}/api/grades`
export const updateGradeUrl = `${API_URL}/api/grades`
export const deleteGradeUrl = `${API_URL}/api/grades`
export const approveGradeUrl = `${API_URL}/api/grades`
export const rejectGradeUrl = `${API_URL}/api/grades`
export const fetchGradesUrl = `${API_URL}/api/grades`
export const fetchGradeByIdUrl = `${API_URL}/api/grades`

// Tabulation Endpoints
export const createTabulationUrl = `${API_URL}/api/grades/tabulations/create`
export const updateTabulationUrl = `${API_URL}/api/grades/tabulations/update`
export const deleteTabulationUrl = `${API_URL}/api/grades/tabulations/delete`
export const submitTabulationUrl = `${API_URL}/api/grades/tabulations`
export const fetchTabulationsUrl = `${API_URL}/api/grades/tabulations`
export const fetchTabulationByIdUrl = `${API_URL}/api/grades/tabulations`
export const fetchApprovalQueueUrl = `${API_URL}/api/grades/tabulations/approval-queue`
export const fetchSubmissionDetailsUrl = `${API_URL}/api/grades/tabulations/submission`
export const detectMissingGradesUrl = `${API_URL}/api/grades/tabulations`
export const reviewTabulationUrl = `${API_URL}/api/grades/tabulations`
export const fetchStudentGradesUrl = (studentId: string) => `${API_URL}/api/grades/tabulations/student/${studentId}/grades`

// Bulletin Endpoints
export const fetchBulletinUrl = `${API_URL}/api/bulletin`
export const fetchBulletinsUrl = `${API_URL}/api/bulletin`

export const fetchExercicesUrl = `${API_URL}/api/exercices`
export const fetchExerciceByIdUrl = `${API_URL}/api/exercices`
export const createExerciceUrl = `${API_URL}/api/exercices/create`
export const updateExerciceUrl = `${API_URL}/api/exercices/update`
export const deleteExerciceUrl = `${API_URL}/api/exercices/delete`
export const endExerciceUrl = `${API_URL}/api/exercices/do`
export const undoExerciceUrl = `${API_URL}/api/exercices/undo`
export const fetchAllExercicesUrl = `${API_URL}/api/exercices/all`

export const fetchVideoGalleryUrl = `${API_URL}/api/video-gallery`
export const fetchVideoGalleryByIdUrl = `${API_URL}/api/video-gallery`
export const fetchAllVideoGalleryUrl = `${API_URL}/api/video-gallery/all`
export const createVideoGalleryUrl = `${API_URL}/api/video-gallery/create`
export const updateVideoGalleryUrl = `${API_URL}/api/video-gallery/update`
export const deleteVideoGalleryUrl = `${API_URL}/api/video-gallery/delete`

// AI Quiz Competition API endpoints
export const fetchCompetitionsUrl = `${API_URL}/api/competitions`
export const fetchCompetitionByIdUrl = `${API_URL}/api/competitions`
export const createCompetitionUrl = `${API_URL}/api/competitions/create`
export const updateCompetitionUrl = `${API_URL}/api/competitions/update`
export const deleteCompetitionUrl = `${API_URL}/api/competitions/delete`
export const startCompetitionUrl = `${API_URL}/api/competitions`
export const submitCompetitionUrl = `${API_URL}/api/competitions/submit`
export const getCompetitionLeaderboardUrl = `${API_URL}/api/competitions`
export const getCompetitionRankUrl = `${API_URL}/api/competitions`
export const getCompetitionStatsUrl = `${API_URL}/api/competitions`
export const getUserCompetitionHistoryUrl = `${API_URL}/api/competitions/user/history`
export const getChildCompetitionScoresUrl = `${API_URL}/api/competitions/child`
export const getQuizStatusUrl = `${API_URL}/api/competitions/quiz`
/** GET /api/competitions/score/:scoreId/answers — Admin/Teacher only; 403 for students/parents */
export const getScoreAnswersUrl = `${API_URL}/api/competitions/score`
/** GET /api/champions-board — All competitions with top 3 + myResult for feed (no filters) */
export const getChampionsBoardUrl = `${API_URL}/api/champions-board`
/** POST /api/competitions/video/:videoId/scores/empty — Admin only; empty all quiz score cells for a video */
export const clearCompetitionScoresByVideoUrl = `${API_URL}/api/competitions/video`

/** GET /api/national-exams?subject=&type= — backend scopes results to the authenticated user (do not send level). */
export const nationalExamsUrl = `${API_URL}/api/national-exams`
/** Homepage slices: recommended, continue, catalog — see docs/frontend/NATIONAL-EXAMS-HOMEPAGE-ARCHITECTURE.md */
export const nationalExamsHomepageUrl = `${nationalExamsUrl}/homepage`
export const nationalExamsRecommendedUrl = `${nationalExamsUrl}/recommended`
export const nationalExamsPopularUrl = `${nationalExamsUrl}/popular`
export const nationalExamsContinueUrl = `${nationalExamsUrl}/continue`
export const nationalExamsCatalogUrl = `${nationalExamsUrl}/catalog`
export const nationalExamsHistoryUrl = `${nationalExamsUrl}/history`
/** Remove one continue row — `POST /api/national-exams/history/:examId` */
export const nationalExamHistoryItemUrl = (examId: string) =>
  `${nationalExamsHistoryUrl}/${encodeURIComponent(examId)}`
/** User bookmarks — `GET` list, `POST /saved` add `{ examId }`, `POST /saved/:examId` unsave */
export const nationalExamsSavedUrl = `${nationalExamsUrl}/saved`
export const nationalExamSavedItemUrl = (examId: string) =>
  `${nationalExamsSavedUrl}/${encodeURIComponent(examId)}`
export const nationalExamDownloadCountUrl = (examId: string) =>
  `${nationalExamsUrl}/${encodeURIComponent(examId)}/download`
/** Record view + trending — `POST` body `{ source: "web" | "mobile" }` */
export const nationalExamViewUrl = (examId: string) =>
  `${nationalExamsUrl}/${encodeURIComponent(examId)}/view`
/** Admin national exams: POST create; POST `/update` and `/delete` (body `{ id }`) like exercices/remarques; POST `/:id` partial update still available */
export const nationalExamsAdminUrl = `${API_URL}/api/admin/national-exams`
export const updateNationalExamAdminUrl = `${nationalExamsAdminUrl}/update`
export const deleteNationalExamAdminUrl = `${nationalExamsAdminUrl}/delete`

export const fetchExamsUrl = `${API_URL}/api/exams`
export const fetchExamByIdUrl = `${API_URL}/api/exams`
export const createExamUrl = `${API_URL}/api/exams/create`
export const updateExamUrl = `${API_URL}/api/exams/update`
export const deleteExamUrl = `${API_URL}/api/exams/delete`
export const endExamUrl = `${API_URL}/api/exams/do`
export const undoExamUrl = `${API_URL}/api/exams/undo`
export const fetchAllExamsUrl = `${API_URL}/api/exams/all`

export const fetchTypeExamsUrl = `${API_URL}/api/type-exams`
export const fetchTypeExamByIdUrl = `${API_URL}/api/type-exams`
export const createTypeExamUrl = `${API_URL}/api/type-exams/create`
export const updateTypeExamUrl = `${API_URL}/api/type-exams/update`
export const deleteTypeExamUrl = `${API_URL}/api/type-exams/delete`
export const suspendTypeExamUrl = `${API_URL}/api/type-exams/suspend`
export const activateTypeExamUrl = `${API_URL}/api/type-exams/activate`
export const fetchAllTypeExamsUrl = `${API_URL}/api/type-exams/all`

export const fetchRemarquesUrl = `${API_URL}/api/remarques`
export const fetchRemarqueByIdUrl = `${API_URL}/api/remarques`
export const createRemarqueUrl = `${API_URL}/api/remarques/create`
export const updateRemarqueUrl = `${API_URL}/api/remarques/update`
export const deleteRemarqueUrl = `${API_URL}/api/remarques/delete`
export const checkRemarqueUrl = `${API_URL}/api/remarques/check`
export const fetchAllRemarquesUrl = `${API_URL}/api/remarques/all`

export const fetchTypeRemarquesUrl = `${API_URL}/api/type-remarques`
export const fetchTypeRemarqueByIdUrl = `${API_URL}/api/type-remarques`
export const createTypeRemarqueUrl = `${API_URL}/api/type-remarques/create`
export const updateTypeRemarqueUrl = `${API_URL}/api/type-remarques/update`
export const deleteTypeRemarqueUrl = `${API_URL}/api/type-remarques/delete`
export const suspendTypeRemarqueUrl = `${API_URL}/api/type-remarques/suspend`
export const activateTypeRemarqueUrl = `${API_URL}/api/type-remarques/activate`
export const fetchAllTypeRemarquesUrl = `${API_URL}/api/type-remarques/all`

export const fetchPaymentCategoriesUrl = `${API_URL}/api/payment-categories`
export const fetchPaymentCategoryByIdUrl = `${API_URL}/api/payment-categories`
export const createPaymentCategoryUrl = `${API_URL}/api/payment-categories/create`
export const updatePaymentCategoryUrl = `${API_URL}/api/payment-categories/update`
export const deletePaymentCategoryUrl = `${API_URL}/api/payment-categories/delete`
export const suspendPaymentCategoryUrl = `${API_URL}/api/payment-categories/suspend`
export const activatePaymentCategoryUrl = `${API_URL}/api/payment-categories/activate`
export const fetchAllPaymentCategoriesUrl = `${API_URL}/api/payment-categories/all`
// Class fees endpoints
export const getCategoriesForClassUrl = `${API_URL}/api/payment-categories/for-class`
export const getFeeForCategoryAndClassUrl = `${API_URL}/api/payment-categories`
export const updateClassFeeUrl = `${API_URL}/api/payment-categories`

export const fetchPaymentsUrl = `${API_URL}/api/payments`
export const fetchPaymentByIdUrl = (id: string) => `${API_URL}/api/payments/${id}`
export const createPaymentUrl = `${API_URL}/api/payments/create`
export const updatePaymentUrl = `${API_URL}/api/payments/update`
export const deletePaymentUrl = `${API_URL}/api/payments/delete`
export const suspendPaymentUrl = `${API_URL}/api/payments/suspend`
export const activatePaymentUrl = `${API_URL}/api/payments/activate`

// Billing (student charges + payment allocations — additive; does not replace /api/payments)
export const billingChargesUrl = `${API_URL}/api/billing/charges`
export const billingChargesCreateUrl = `${API_URL}/api/billing/charges/create`
export const billingChargesCreateFromTariffUrl = `${API_URL}/api/billing/charges/create-from-tariff`
export const billingChargesWaiveUrl = `${API_URL}/api/billing/charges/waive`
export const billingChargesCancelUrl = `${API_URL}/api/billing/charges/cancel`
export const billingChargesDeleteUrl = `${API_URL}/api/billing/charges/delete`
export const billingStudentChargesUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/charges`
/** Read-only charge-based period timeline (same auth as /charges). */
export const billingStudentPeriodStatusUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/period-status`
/** Read-only balance snapshot (excludes cancelled/waived per BILLING-API). */
export const billingStudentBalanceUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/balance`
export const billingStudentOverdueSummaryUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/overdue-summary`
/** Payment-centric reporting projection for a student (not charge balance source of truth). */
export const billingStudentPaymentsUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/payments`
export const billingStudentAmountOptionsUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/amount-options`
export const billingStudentPreviewTotalUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/preview-total`
export const billingParentSummaryUrl = `${API_URL}/api/billing/parent/summary`
export const billingAllocationsApplyUrl = `${API_URL}/api/billing/allocations/apply`
export const billingAllocationsRemoveUrl = `${API_URL}/api/billing/allocations/remove`
export const billingPaymentAllocationsUrl = (paymentId: string) =>
  `${API_URL}/api/billing/payments/${paymentId}/allocations`
/** Optional: all PaymentAllocation rows for a student (Payé source of truth). */
export const billingStudentAllocationsUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/allocations`
/** Staff: PaymentAllocation breakdown for a receipt (after apply / apply-fifo). */
export const billingPaymentCoverageUrl = (paymentId: string) =>
  `${API_URL}/api/billing/payments/${paymentId}/coverage`
export const billingReportsOverdueUrl = `${API_URL}/api/billing/reports/overdue`
export const billingReportsSyncOverdueUrl = `${API_URL}/api/billing/reports/sync-overdue`
export const billingPolicyUrl = (establishmentId: string) =>
  `${API_URL}/api/billing/policy/${establishmentId}`
export const billingPolicyUpsertUrl = `${API_URL}/api/billing/policy/upsert`
export const billingPolicyPeriodsUrl = (establishmentId: string) =>
  `${API_URL}/api/billing/policy/${establishmentId}/periods`
export const billingChargesGenerateForStudentUrl = `${API_URL}/api/billing/charges/generate-for-student`
export const billingAllocationsApplyFifoUrl = `${API_URL}/api/billing/allocations/apply-fifo`
export const billingPricingResolveUrl = `${API_URL}/api/billing/pricing/resolve`
export const billingStudentFeeAgreementsUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/fee-agreements`
export const billingFeeAgreementsUpsertUrl = `${API_URL}/api/billing/fee-agreements/upsert`
export const billingFeeAgreementsDeleteUrl = `${API_URL}/api/billing/fee-agreements/delete`
export const billingSchedulesUrl = (establishmentId: string) =>
  `${API_URL}/api/billing/schedules/${establishmentId}`
export const billingSchedulesCreateUrl = `${API_URL}/api/billing/schedules/create`
export const billingSchedulesUpdateUrl = `${API_URL}/api/billing/schedules/update`
export const billingSchedulesDeleteUrl = `${API_URL}/api/billing/schedules/delete`

export const billingVerificationStudentUrl = (studentId: string) =>
  `${API_URL}/api/billing/verification/student/${studentId}`
export const billingVerificationCategoryUrl = (studentId: string, categoryId: string) =>
  `${API_URL}/api/billing/verification/student/${studentId}/category/${categoryId}`

/** Manual billing reminders (staff-only POST). See docs/frontend/BILLING-NOTIFICATIONS.md */
export const billingNotificationPreviewUrl = (studentId: string) =>
  `${API_URL}/api/billing-notifications/preview/${studentId}`
export const billingNotificationSendUrl = (studentId: string) =>
  `${API_URL}/api/billing-notifications/send/${studentId}`
export const billingNotificationSendBulkUrl = `${API_URL}/api/billing-notifications/send-bulk`

export const fetchPeriodsUrl = `${API_URL}/api/periods`
export const fetchPeriodByIdUrl = `${API_URL}/api/periods`
export const fetchAllPeriodsUrl = `${API_URL}/api/periods/all`
export const createPeriodUrl = `${API_URL}/api/periods/create`
export const updatePeriodUrl = `${API_URL}/api/periods/update`
export const deletePeriodUrl = `${API_URL}/api/periods/delete`
export const suspendPeriodUrl = `${API_URL}/api/periods/suspend`
export const activatePeriodUrl = `${API_URL}/api/periods/activate`

export const fetchNotificationsUrl = `${API_URL}/api/notifications`
export const notificationsCountUrl = `${API_URL}/api/notifications/count`
export const updateNotificationUrl = `${API_URL}/api/notifications/seen`
export const markAllNotificationsReadUrl = `${API_URL}/api/notifications/mark-all-read`
export const deleteNotificationUrl = (id: string) => `${API_URL}/api/notifications/${id}`

/** GET /api/chat/admin-status — is admin online? (any authenticated user) */
export const adminStatusUrl = `${API_URL}/api/chat/admin-status`

/** Chat AI (OpenRouter). Per docs/frontend/CHAT-AI-OPENROUTER.md. GET = get/create AI conversation (non-admin); 403 admin, 503 if not configured. */
export const chatAiConversationUrl = `${API_URL}/api/chat/ai/conversation`
/** POST = send message to AI; body { conversationId, content }; returns { userMessage, aiMessage, conversationId }. 503 if key/bot missing. */
export const chatAiMessageUrl = `${API_URL}/api/chat/ai/message`

/** Support chat with admin: conversations and messages (saved, persisted) */
export const chatConversationsUrl = `${API_URL}/api/chat/conversations`
export const chatConversationWithAdminUrl = `${API_URL}/api/chat/conversations/with-admin`
/** POST /api/chat/conversations/with-user/:userId — get or create conversation with a specific user (admin only) */
export const chatConversationWithUserUrl = (userId: string) =>
  `${API_URL}/api/chat/conversations/with-user/${userId}`
/** POST /api/chat/conversations/start-new — archive current conversation and create new active one; history kept (non-admin only) */
export const chatStartNewConversationUrl = `${API_URL}/api/chat/conversations/start-new`
export const chatConversationMessagesUrl = (id: string) =>
  `${API_URL}/api/chat/conversations/${id}/messages`
/** GET /api/chat/rooms/:roomId/messages — messages by roomId (e.g. after refresh when only roomId available) */
export const chatRoomMessagesUrl = (roomId: string) =>
  `${API_URL}/api/chat/rooms/${encodeURIComponent(roomId)}/messages`
export const chatSendMessageUrl = `${API_URL}/api/chat/messages`
export const chatMarkConversationReadUrl = (id: string) =>
  `${API_URL}/api/chat/conversations/${id}/read`
/** DELETE /api/chat/conversations/:id — delete conversation and all messages (admin only) */
export const chatDeleteConversationUrl = (id: string) => `${API_URL}/api/chat/conversations/${id}`

// Chatbot API endpoints (Q&A management)
export const fetchChatbotResponsesUrl = `${API_URL}/api/chatbot/responses`
export const fetchChatbotActiveResponsesUrl = `${API_URL}/api/chatbot/active-responses`
export const createChatbotResponseUrl = `${API_URL}/api/chatbot/responses`
export const updateChatbotResponseUrl = (id: string) => `${API_URL}/api/chatbot/responses/${id}`
export const deleteChatbotResponseUrl = (id: string) => `${API_URL}/api/chatbot/responses/${id}`
export const toggleChatbotResponseStatusUrl = (id: string) => `${API_URL}/api/chatbot/responses/${id}/toggle-status`
export const searchChatbotResponsesUrl = `${API_URL}/api/chatbot/search`

// Inventory Management API endpoints
export const inventoryUrl = `${API_URL}/api/inventory`
export const inventoryTypesUrl = `${API_URL}/api/inventory-types`
export const createInventoryUrl = `${API_URL}/api/inventory/create`
export const updateInventoryUrl = `${API_URL}/api/inventory/update`
export const deleteInventoryUrl = `${API_URL}/api/inventory/delete`
export const assignInventoryUrl = `${API_URL}/api/inventory/assign`
export const unassignInventoryUrl = `${API_URL}/api/inventory/unassign`
export const maintenanceInventoryUrl = `${API_URL}/api/inventory/maintenance`

// Inventory Types API endpoints
export const createInventoryTypeUrl = `${API_URL}/api/inventory-types/create`
export const updateInventoryTypeUrl = `${API_URL}/api/inventory-types/update`
export const deleteInventoryTypeUrl = `${API_URL}/api/inventory-types/delete`
export const activateInventoryTypeUrl = `${API_URL}/api/inventory-types/activate`
export const suspendInventoryTypeUrl = `${API_URL}/api/inventory-types/suspend`

// Expense Management API endpoints (All mutations use POST to avoid CORS)
export const fetchExpensesUrl = `${API_URL}/api/expenses`
export const fetchExpenseByIdUrl = (id: string) => `${API_URL}/api/expenses/${id}`

export const foldersUrl = `${API_URL}/api/folders`
export const folderTreeUrl = `${foldersUrl}/tree`
export const folderUpdateUrl = (folderId: string) => `${foldersUrl}/${folderId}/update`
export const folderDeleteUrl = (folderId: string) => `${foldersUrl}/${folderId}/delete`

export const filesUrl = `${API_URL}/api/files`
export const fileUpdateUrl = (fileId: string) => `${filesUrl}/${fileId}/update`
export const fileDownloadUrl = (fileId: string) => `${filesUrl}/${fileId}/download`
export const fileTrashUrl = (fileId: string) => `${filesUrl}/${fileId}/trash`
export const fileRestoreUrl = (fileId: string) => `${filesUrl}/${fileId}/restore`
export const filePermanentDeleteUrl = (fileId: string) => `${filesUrl}/${fileId}/delete`
export const fileAddLabelUrl = (fileId: string) => `${filesUrl}/${fileId}/labels/add`
export const fileRemoveLabelUrl = (fileId: string) => `${filesUrl}/${fileId}/labels/remove`
export const fileFlagUrl = (fileId: string, flagType: string) => `${filesUrl}/${fileId}/flags/${flagType}`
export const fetchRolesUrl = `${API_URL}/api/roles`
export const createExpenseUrl = `${API_URL}/api/expenses`
export const updateExpenseUrl = `${API_URL}/api/expenses/update` // POST method
export const deleteExpenseUrl = `${API_URL}/api/expenses/delete` // POST method

// Push notification subscriptions
export const subscribePushUrl = `${API_URL}/api/push-subscriptions/subscribe`
export const unsubscribePushUrl = `${API_URL}/api/push-subscriptions/unsubscribe`

// Payroll API endpoints
export const fetchPayslipsUrl = `${API_URL}/api/payroll`
export const fetchAllPayslipsUrl = `${API_URL}/api/payroll/all`
export const fetchPayslipsByUserUrl = (userId: string) => `${API_URL}/api/payroll/user/${userId}`
export const fetchPayslipsByPeriodUrl = (month: number, year: number) => `${API_URL}/api/payroll/period/${month}/${year}`
export const fetchPayslipByIdUrl = (id: string) => `${API_URL}/api/payroll/${id}`
export const createPayslipUrl = `${API_URL}/api/payroll/create`
export const updatePayslipUrl = `${API_URL}/api/payroll/update`
export const finalizePayslipUrl = `${API_URL}/api/payroll/finalize`
export const markPayslipPaidUrl = `${API_URL}/api/payroll/mark-paid`
export const deletePayslipUrl = `${API_URL}/api/payroll/delete`
export const fetchDeletedPayslipsUrl = `${API_URL}/api/payroll/deleted`
export const restorePayslipUrl = `${API_URL}/api/payroll/restore`

// Payroll Categories API endpoints
export const fetchPayrollCategoriesUrl = `${API_URL}/api/payroll-categories`
export const fetchPayrollCategoryByIdUrl = (id: string) => `${API_URL}/api/payroll-categories/${id}`
export const fetchAllPayrollCategoriesUrl = `${API_URL}/api/payroll-categories/all`
export const createPayrollCategoryUrl = `${API_URL}/api/payroll-categories/create`
export const updatePayrollCategoryUrl = `${API_URL}/api/payroll-categories/update`
export const deletePayrollCategoryUrl = `${API_URL}/api/payroll-categories/delete`
export const suspendPayrollCategoryUrl = `${API_URL}/api/payroll-categories/suspend`
export const activatePayrollCategoryUrl = `${API_URL}/api/payroll-categories/activate`

// Administrative documents (templates + generated PDFs)
export const documentTemplatesUrl = `${API_URL}/api/document-templates`
export const documentTemplatesUpdateUrl = `${API_URL}/api/document-templates/update`
export const documentTemplatesDeleteUrl = `${API_URL}/api/document-templates/delete`
export const documentsUrl = `${API_URL}/api/documents`
export const documentsGenerateUrl = `${API_URL}/api/documents/generate`
export const documentByIdUrl = (id: string) => `${API_URL}/api/documents/${id}`
/** Stream/download generated file (PDF preferred). */
export const documentDownloadUrl = (id: string) => `${API_URL}/api/documents/${id}/download`
export const documentPrintUrl = (id: string) => `${API_URL}/api/documents/${id}/print`
export const documentHistoryUrl = (id: string) => `${API_URL}/api/documents/${id}/history`
export const documentArchiveUrl = (id: string) => `${API_URL}/api/documents/${id}/archive`
export const documentsDeleteUrl = `${API_URL}/api/documents/delete`
export const documentDeleteByIdUrl = (id: string) => `${API_URL}/api/documents/${id}/delete`
export const documentVerifyUrl = (code: string) => `${API_URL}/api/documents/verify/${code}`